<template>
    <div class="bulma">
        <div class="modal is-active"
             v-if="show"
        >
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ trans.modal_title }}
                    </p>
                    <a
                        @click="closeModal"
                        :title="trans.close_modal_title"
                    >
                        <svg>
                            <use xlink:href="#icon-cross"></use>
                        </svg>
                    </a>
                </header>
                <component
                    class="comment-content"
                    :is="selectedComponent"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "PublishArticleMainModal",
    props: {
        initTrans: Object,
        initDocumentRoute: String,
        initDomainName: String,
    },
    mounted() {
        this.setTrans(this.initTrans);
        this.setRoutes({
            document: this.initDocumentRoute,
            domain: this.initDomainName,
        });
    },
    computed: {
        ...mapGetters('bx24ActivityStreamManager', {
            show: 'publishArticleMainModalIsShown',
        }),
        ...mapGetters('bx24ActivityStreamManager', [
            'trans',
            'selectedComponent',
        ]),
    },
    methods: {
        ...mapActions('bx24ActivityStreamManager', {
            hideModal: 'hidePublishArticleMainModalModal',
         }),
        ...mapActions('bx24ActivityStreamManager', [
            'setTrans',
            'setRoutes',
        ]),
        closeModal() {
            this.hideModal();
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    svg {
        width: 16px;
        height: 16px;
        fill: $white;
        &:hover {
            fill: $black;
        }
    }
</style>
